import useFetchObjects from "../../api/useFetchObjects";

const useAboutStats = () => {
  return useFetchObjects(
    ["about-stats"], // cache key
    "report/about-stats/", // endpoint
    null,
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
    },
  );
};

export default useAboutStats;
